export default {
	title: "dark",
	colors: {
		brand_primary: "#01e59b",
		brand_orange: "#FBBB00",

		neutral_strong: "#353546",
		neutral_stronger: "#23242f",
		neutral_strongest: "#13141b",
		neutral_medium: "#8f8f9a",
		neutral_smooth: "#caced4",
		neutral_smoother: "#e7eaee",
		neutral_smoothest: "#ffffff",

		feedback_info: "#57D6F8",
		feedback_success: "#0fef83",
		feedback_positive: "#86ffc5",
		feedback_warning: "#f0960f",
		feedback_negative: "#e66f87",
		feedback_error: "#d30d48",
	},
	fontSizes: {
		small: "0.75rem",
		default: "0.875rem",
		huge: "1rem",
		tiny: "1.5rem",
	},
	spacing: {
		small: "0.625rem",
		default: "0.75rem",
		vertical: "0.75rem 0",
		horizontal: "0 0.75rem",
		huge: "1.5rem",
		tiny: "1.875rem",
	},
};
